import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=a43297f8&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&id=a43297f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43297f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43297f8')) {
      api.createRecord('a43297f8', component.options)
    } else {
      api.reload('a43297f8', component.options)
    }
    module.hot.accept("./Share.vue?vue&type=template&id=a43297f8&scoped=true&", function () {
      api.rerender('a43297f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/Share.vue"
export default component.exports